export default __webpack_public_path__ + "static/media/ExplorerLibraryHeaderGraphic.dc80b614.svg";